// import request from '@/utils/request'
// 获取全局的 axios 实例
let axiosInstance = null;

// 这个方法需要在 Vue 应用初始化后调用
export function setAxiosInstance(axios) {
  axiosInstance = axios;
}

// 获取知识点列表（分页）
export function getKnowledgePoints(params) {
  return axiosInstance({
    url: '/points/knowledge-points',
    method: 'get',
    params: {
      page: params.page || 1,
      page_size: params.pageSize || 10,
      search: params.search,
      level: params.level
    }
  })
}

// 获取所有知识点（不分页，树形结构）
export function getAllKnowledgePoints() {
  return axiosInstance({
    url: '/points/knowledge-points/all',
    method: 'get'
  })
}

// 获取扁平列表（用于级联选择器）
export function getKnowledgePointsFlat() {
  return axiosInstance({
    url: '/points/knowledge-points/flat',
    method: 'get'
  })
}

// 获取扁平列表（用于新增题目的地方）
export function getKnowledgePointsFlat3() {
  return axiosInstance({
    url: '/points/knowledge-points/flat3',
    method: 'get'
  })
}

// 获取知识点详情
export function getKnowledgePoint(id) {
  return axiosInstance({
    url: `/points/knowledge-points/${id}`,
    method: 'get'
  })
}

// 创建知识点
export function createKnowledgePoint(data) {
  return axiosInstance({
    url: '/points/knowledge-points',
    method: 'post',
    data
  })
}

// 更新知识点
export function updateKnowledgePoint(id, data) {
  return axiosInstance({
    url: `/points/knowledge-points/${id}`,
    method: 'put',
    data
  })
}

// 删除知识点
export function deleteKnowledgePoint(id) {
  return axiosInstance({
    url: `/points/knowledge-points/${id}`,
    method: 'delete'
  })
}